import logo from './logo.svg';
import './App.css';
import { Analytics } from "@vercel/analytics/react"


function App() {
    return (
        <div className="App">
            <header style={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                fontSize: 'calc(10px + 2vmin)',
                fontWeight: 'bold',
            }}>
                Cry about it
            </header>
            <Analytics />
        </div>
    );
}

export default App;
